import { CbhFeatureFlag } from "@src/appV2/FeatureFlags/CbhFeatureFlag";
import { useCbhFlag } from "@src/appV2/FeatureFlags/useCbhFlag";

export type BookingOrderingCohort = "book_first" | "screen_first" | "screen_last";

export function useBookingOrderingCohort(): BookingOrderingCohort {
  return useCbhFlag(CbhFeatureFlag.PLACEMENT_BOOKING_FLOW_ORDER, {
    defaultValue: "screen_first",
  });
}
